var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrx01 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF060A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tron"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M473.7,153.8c-22.7-20.9-54.1-52.9-79.6-75.6l-1.5-1.1c-2.5-2-5.4-3.6-8.4-4.7l0,0C322.6,60.9,35.7,7.3,30.1,8 c-1.6,0.2-3.1,0.8-4.4,1.7l-1.4,1.1c-1.8,1.8-3.1,4-3.9,6.4l-0.4,1v5.4v0.8c32.3,89.9,159.8,384.5,184.9,453.6 c1.5,4.7,4.4,13.6,9.8,14.1h1.2c2.9,0,15.1-16.2,15.1-16.2s219-265.6,241.2-293.9c2.9-3.5,5.4-7.2,7.6-11.2 C480.8,164.4,478.6,158,473.7,153.8z M287.2,184.7l93.5-77.5l54.8,50.5L287.2,184.7z M250.9,179.7L90,47.8l260.4,48L250.9,179.7z  M265.4,214.2l164.7-26.5L241.8,414.6L265.4,214.2z M68.1,60.9l169.3,143.7l-24.5,210.1L68.1,60.9z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrx01);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TRX-01.e496ba6e696ebbdc6c6bb387233e62d5.svg";